export abstract class BaseDto<T> {
    public constructor(init?: Partial<T>) {
        Object.assign(this, init);
    }
}
